import type * as React from 'react';

/**
 * Merges multiple refs into a single ref callback.
 * @param refs
 * @returns Ref<any>
 * @see https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
 * @example
 * const ref = mergeRefs([ref1, ref2, ref3]);
 * <div ref={ref} />
 */
// eslint-disable-next-line func-style
export function mergeRefs<T = any>(
  refs: Array<React.LegacyRef<T> | React.MutableRefObject<T>>
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}
